import React from 'react'
import PropTypes from 'prop-types'
import { Box, Divider, Text } from 'pcln-design-system'
import { PackagesSearchContainer } from '@pcln/home-components'

// TODO: SETI clean up for HP_BUTTON_COLOR
import PackagesSearchForm from '../search-forms/PackagesSearchForm'
import validatePackage from '../search-forms/validatePackage'

import withAnalytics from './withAnalytics'
import withTypeAhead from './withTypeAhead'
import * as PCLNAnalytics from '../../utils/PCLN-Analytics'
import packagesSearch from '../../utils/packages-search'
import vpContent from '../../constants/vacation-package-content'
import { BootstrapDataContext } from '../../contexts'
import {
  persistSearchData
} from '../../utils/local-forage'
import {
  PACKAGE_SEARCH_DATA
} from '../../constants/Constants'

const defaultTripTypesInfo = [
  {
    id: 'tripTypeAH',
    tripType: 'STAY:FLY',
    typeLabel: 'Hotel + Flight'
  },
  {
    id: 'tripTypeAHC',
    tripType: 'STAY:FLY:DRIVE',
    typeLabel: 'Hotel + Flight + Car'
  },
  {
    id: 'tripTypeAC',
    tripType: 'FLY:DRIVE',
    typeLabel: 'Flight + Car'
  },
  {
    id: 'tripTypeHC',
    tripType: 'STAY:DRIVE',
    typeLabel: 'Hotel + Car'
  }
]

const INITIAL_VALUES = {
  startLocation: '',
  endLocation: '',
  startDate: '',
  endDate: '',
  roomCount: 1,
  adultCount: 2,
  childrenCount: 0,
  childrenAges: [],
  startTime: '12:00',
  endTime: '12:00',
  oneWay: false,
  tripType: 'STAY:FLY',
  pickupCarSomewhere: false,
  rcLocation: '',
  pickupCarIncludeAirport: true,
  rcPickupDate: '',
  rcDropoffDate: '',
  rcPickupTime: '10:00',
  rcDropoffTime: '10:00'
}

const getPackagesTripType = tripType => {
  switch (tripType) {
    case 'STAY:FLY:DRIVE':
      return 'Flight + Hotel + Car'
    case 'FLY:DRIVE':
      return 'Flight + Car'
    case 'STAY:DRIVE':
      return 'Hotel + Car'
    case 'STAY:FLY':
    default:
      return 'Flight + Hotel'
  }
}

const PackagesTypeAheadForm = withTypeAhead(PackagesSearchForm)
// TODO: W. partial-stay, the new /shop/search URL search API does not support
//       query string params yet. So this method is a backward-compatibility to
//       still fire the /shop/search via the legacy POST search API.

const Packages = withAnalytics({
  action: 'VP Search',
  events: {
    tripType: values => getPackagesTripType(values.tripType),
    startLocation: values =>
      values.startLocationObject && `From_${values.startLocation}`,
    endLocation: values =>
      values.endLocationObject && `To_${values.endLocation}`,
    startDate: 'Depart_Date',
    endDate: values => values.endDate && 'Return_Date',
    roomCount: values => `${values.roomCount} Rooms`,
    adultCount: values => `${values.adultCount} Adults`,
    partialStay: values => (values.partialStay && values.tripType !== 'STAY:DRIVE' ? 'Checked' : 'Unchecked'),
    childrenAges: 'ChildAges',
    childrenCount: values => `${values.childrenCount} Children`
  }
})(
  class extends React.Component {
    static contextType = BootstrapDataContext

    static propTypes = {
      initValues: PropTypes.func,
      initialDateValues: PropTypes.shape({
        endDate: PropTypes.string,
        startDate: PropTypes.string
      }),
      packagesFormSavedValues: PropTypes.object
    }

    static defaultProps = {
      initialDateValues: {
        endDate: '',
        startDate: ''
      }
    }

    constructor (props) {
      super(props)
      this.state = {}
    }

    handleSubmit = values => {
      // TODO: Retire the if block legacy partial stay search code, when new
      //    shop/search URL search supports partial stay.
      const isPartialStayDateValid =
        !!values.partialStay &&
        (values.hotelStartDate !== values.startDate ||
          values.hotelEndDate !== values.endDate)

      persistSearchData(PACKAGE_SEARCH_DATA, values)

      packagesSearch({
        ...values,
        isPartialStayDateValid:
          isPartialStayDateValid && values.tripType !== 'STAY:DRIVE'
      })

      if (values.pickupCarSomewhere) {
        PCLNAnalytics.send({
          action: 'H+C - Different Location Search',
          category: 'PCLN_HOME'
        })
      }

      if (!values.pickupCarIncludeAirport) {
        PCLNAnalytics.send({
          action: 'Hide On Airport Inventory',
          category: 'PCLN_HOME'
        })
      }

      if (isPartialStayDateValid) {
        PCLNAnalytics.send({
          action: 'VP Search Button',
          data: 'Partial search'
        })
      }

      if (values.isRecommendedTrip) {
        PCLNAnalytics.send({
          action: 'VP Search Button',
          data: 'Recommended Trip search'
        })
      }

      if (!isPartialStayDateValid && !values.isRecommendedTrip) {
        PCLNAnalytics.send({
          action: 'VP Search Button',
          data: 'Normal search'
        })
      }
      // todo: look into invalid submit clicks
    }

    render () {
      const {
        isMobile = false
      } = this.context

      const packagesInitialValues = {
        ...INITIAL_VALUES,
        ...this.state.packagesFormSavedValues,
        ...this.props.packagesFormSavedValues
      }

      return (
        <Box width={1}>
          <Box px={!isMobile ? 3 : null} py={3}>
            <PackagesSearchContainer
              {...this.props}
              enableReinitialize
              validate={validatePackage}
              initialValues={packagesInitialValues}
              onSubmit={this.handleSubmit}
              tripTypesInfo={defaultTripTypesInfo}
              render={props => (
                <PackagesTypeAheadForm
                  {...props}
                  typeAhead={{
                    endpoint: 'vacations',
                    keys: ['startLocation', 'endLocation', 'rcLocation']
                  }}
                />
              )}
            />
          </Box>
          {!isMobile && [
            <Divider my={0} />,
            <Box
              px={3}
              py={3}
              style={{
                height: 48,
                borderBottomRightRadius: '6px',
                borderBottomLeftRadius: '6px'
              }}
              color='background.light'
            >
              <Text fontSize={1} textAlign='center' color='text.light'>
                {vpContent.newVPFormBumper}
              </Text>
            </Box>
          ]}
        </Box>
      )
    }
  }
)

export default Packages
